import appConfig from "../constants/config";
import { elementDisplay, mandatoryInput, disableInput } from "./elementControl";
import { checkInputDecimal, decimalRemove, is45RoundingApplies } from "./inputValueFormat";
import { useGlobalLocation } from "../pages/Layout/Layout";
import { getGlobalLocation } from "./globalManager";
import { format } from "date-fns";
import { getObjectAttachment, getObjectRequester } from "./localStorage/localStorage";
import { isElementVisible } from "./elementControl";
import { subCatInputOnChange } from "../pages/ClaimItems/services/claimDetailUtils";

const isNullOrEmpty = (value: any): boolean =>
  value == null || value == "" || value == undefined || value == "undefined";



export function bindDDLTaxRate(
  count: number,
  display_data: any,
  category_id: number,
  date: Date,
  range: string,
  taxoption: string[],
  id: number,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  isSelectedTaxOnly: boolean,
  number_of_decimal: number,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
) {
  let current_user_information: any;

  // Get user information
  const storedUserInfo = localStorage.getItem("objRequestor");
  if (storedUserInfo) {
    current_user_information = JSON.parse(storedUserInfo);
  }
  
  const zero = 0;
  const taxCompulsory = localStorage.getItem("TaxCompulsory");
  const tempTextWord = "% Tax is not applicable";

  // Clear the tax code dropdown for CN country if not limited to selected tax only
  if (!isSelectedTaxOnly && current_user_information?.country_code == "CN") {
    const ddlTaxCodeCN = document.getElementById(`ddlTaxCodeCN_${id}`) as HTMLSelectElement;
    // if (ddlTaxCodeCN) ddlTaxCodeCN.innerHTML = "";
    handleBindDDL && handleBindDDL(`taxCodeCN`, []);
  }

  let taxCodeCNOptions = bindDDL?.[`taxCodeCN`] || [];

  // Iterate through each tax column
  for (let a = 0; a < count; a++) {
    let taxColNum = a + 1;

    display_data.forEach((d:any) => {
      // Check if the category ID matches and if the tax code is applicable
      if (d.subcategory_id == category_id) {
        const compareDate = new Date(d.effectiveDate);
        const expiryDate = d.expiryDate ? new Date(d.expiryDate) : null;

        if (date >= compareDate && d.range == range && (date <= (expiryDate ?? date))) {
          if (d.taxCode == taxoption[a]) {
            console.log(taxoption[a]);
            console.log("The d.rate is : " + d.rate);

            handleInputChange(`ddlTaxCode${taxColNum}_${id}`, d.rate);
            handleInputChange(`ddlTaxCode${taxColNum}_${id}_codevalue`, d.taxCode);
            handleInputChange(`ddlTaxCode${taxColNum}_${id}_taxrate`, d.rate);
            elementDisplay(`#taxcodechecking${taxColNum}_${id}`, true, "div");
            mandatoryInput(`#txtcoderate${taxColNum}_${id}`, false, "text");
            //handleInputChange(`txtcoderate${taxColNum}_${id}`, isNullOrEmpty(inputValues[`txtClaimAmount${id}`]) ? zero.toFixed(number_of_decimal) : inputValues[`txtcoderate${taxColNum}_${id}`]);
            disableInput(`#txtcoderate${taxColNum}_${id}`, false, "text");

            // Handle CN-specific logic for the tax dropdown
            if (current_user_information?.country_code == "CN") {

              // let exists = Array.from(ddlTaxCodeCN.options).some((option) => option.value == d.taxCode);
              let exists = taxCodeCNOptions.some(
                            (option: any) => option.value == d.taxCode
                          );

              // Only add if the tax code doesn't already exist in the dropdown
              if (!exists) {
                taxCodeCNOptions.push({ label: d.rate, value: d.taxCode });
              }

               elementDisplay(`#taxcodecheckingCN_${id}`, true, "div");
               elementDisplay(`#taxcodechecking${taxColNum}_${id}`, false, "div");
            }

            // Handle hiding or showing tax column based on taxCompulsory value
            const hideTax = document.getElementById(`hidetax${taxColNum}_${id}`) as HTMLElement;
            const lblHideTaxMsg = document.getElementById(`lblhidetaxmsg${taxColNum}_${id}`) as HTMLElement;

            if (taxCompulsory == "No") {
                elementDisplay(`#hidetax${taxColNum}_${id}`, true, "div");
              if (lblHideTaxMsg) {
                lblHideTaxMsg.innerHTML = `${d.rate} ${tempTextWord}`;
                if (current_user_information?.country_code == "CN") {
                  elementDisplay(`#hidetax${taxColNum}_${id}`, false, "div");
                }
              }
            } else if (taxCompulsory == "Yes" && count >= 1) {
              elementDisplay(`#hidetax${taxColNum}_${id}`, true, "div");

              if (lblHideTaxMsg) {
                lblHideTaxMsg.innerHTML = `${d.rate} ${tempTextWord}`;
                 elementDisplay(`#taxcompulsorymsg_${id}`, true, "div");

                // Hide tax checkbox for CN or PH countries
                if (current_user_information?.country_code == "CN" || current_user_information?.country_code == "PH") {
                  elementDisplay(`#hidetax${taxColNum}_${id}`, false, "div");
                }
              }
            }
            // Begin,Saber,20261007,INC-1030470 - handleInputChange is async, so the rate just
            // written is not in inputValues yet. Calculate (or restore the imported amount)
            // with the rate in hand, otherwise the tax amount stays at the setDefaultTax zero.
            applyBoundTaxAmount(
              id,
              taxColNum,
              d.rate,
              d.taxCode,
              inputValues,
              handleInputChange,
              number_of_decimal
            );
            // End,Saber,20261007,INC-1030470
          }
        }
      }
    });
  }

  handleBindDDL &&
  handleBindDDL(
    'taxCodeCN',
    taxCodeCNOptions
  );
}


export function bindDDLTaxRateDtl(
  count: number,
  display_data: any,
  category_id: number,
  detail_id: number,
  date: Date,
  range: string,
  taxoption: string[],
  id: number,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  number_of_decimal:number,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }

) {
  
  const zero = 0;
  const taxCompulsory = !isNullOrEmpty(localStorage.getItem("TaxCompulsory")) ? localStorage.getItem("TaxCompulsory") : null;
  const tempTextWord = "% Tax is not applicable";

  let current_user_information: any;

  // Handle undefined user information
  if (typeof current_user_information == "undefined") {
    const storedUserInfo = localStorage.getItem("objRequestor");
    if (!isNullOrEmpty(storedUserInfo)) {
      current_user_information = JSON.parse(storedUserInfo!);
    }
  }

  // Check for CN country code and visibility of specific dropdowns
  if (current_user_information?.country_code == "CN") {
    if (
        !(document.getElementById(`ddlTransportType${id}`) as HTMLSelectElement)?.classList.contains("d-none") ||
        !(document.getElementById(`ddlTransportType${id}`) as HTMLSelectElement)?.classList.contains("d-none")
    ) {
      // const ddlTaxCodeCN = document.getElementById(`ddlTaxCodeCN_${id}`);
      handleBindDDL && handleBindDDL(`taxCodeCN`, []);
    }
  }

  let taxCodeCNOptions = bindDDL?.[`taxCodeCN`] || [];

  // Loop through each tax column and bind values based on conditions
  for (let a = 0; a < count; a++) {
    let taxColNum = a + 1;

    display_data.forEach((d:any) => {
      if (d.subcategory_id == category_id && d.detail_id == detail_id) {
        const compareDate = new Date(d.effectiveDate);

        if (date >= compareDate && d.range == range && d.taxCode == taxoption[a]) {

            handleInputChange(`ddlTaxCode${taxColNum}_${id}`, d.rate);
            handleInputChange(`ddlTaxCode${taxColNum}_${id}_codevalue`, d.taxCode);
            handleInputChange(`ddlTaxCode${taxColNum}_${id}_taxrate`, d.rate);
            elementDisplay(`#taxcodechecking${taxColNum}_${id}`, true, "div");
            mandatoryInput(`#txtcoderate${taxColNum}_${id}`, false, "text");
            //handleInputChange(`txtcoderate${taxColNum}_${id}`, zero.toFixed(number_of_decimal));
            disableInput(`#txtcoderate${taxColNum}_${id}`, false, "text");

            // Begin,Saber,20261007,INC-1030470 - same stale-state gap as bindDDLTaxRate.
            // Transport (and phone) tax rates are bound here after the user picks a detail type.
            applyBoundTaxAmount(
              id,
              taxColNum,
              d.rate,
              d.taxCode,
              inputValues,
              handleInputChange,
              number_of_decimal
            );
            // End,Saber,20261007,INC-1030470

          // Handle CN country-specific conditions
          if (current_user_information?.country_code == "CN") {
            // let exists = Array.from(ddlTaxCodeCN.options).some((option) => option.value == d.taxCode);
            let exists = taxCodeCNOptions.some(
                          (option: any) => option.value == d.taxCode
                        );

            // Only add if the tax code doesn't already exist in the dropdown
            if (!exists) {
              taxCodeCNOptions.push({ label: d.rate, value: d.taxCode });
            }
            elementDisplay(`#taxcodecheckingCN_${id}`, true, "div");
            elementDisplay(`#taxcodechecking${taxColNum}_${id}`, false, "div");

          }

          // Checkbox to hide tax column
          if (taxCompulsory == "No") {
            elementDisplay(`#hidetax${taxColNum}_${id}`, true, "div");
            const lblHideTaxMsg = document.getElementById(`lblhidetaxmsg${taxColNum}_${id}`) as HTMLElement;

            if (lblHideTaxMsg) {
              lblHideTaxMsg.innerHTML = `${d.rate} ${tempTextWord}`;

              if (current_user_information?.country_code == "CN") {
                elementDisplay(`#hidetax${taxColNum}_${id}`, false, "div");
              }
            }
          } else if (taxCompulsory == "Yes" && count >= 1) {
            elementDisplay(`#hidetax${taxColNum}_${id}`, true, "div");
            elementDisplay(`#taxcompulsorymsg_${id}`, true, "div");
            const lblHideTaxMsg = document.getElementById(`lblhidetaxmsg${taxColNum}_${id}`) as HTMLElement;

            if (lblHideTaxMsg) {
              lblHideTaxMsg.innerHTML = `${d.rate} ${tempTextWord}`;
              if (
                current_user_information?.country_code == "CN" ||
                current_user_information?.country_code == "PH"
              ) {
                elementDisplay(`#hidetax${taxColNum}_${id}`, false, "div");
              }
            }
          }
        }
      }
    });
  }

  handleBindDDL &&
  handleBindDDL(
    'taxCodeCN',
    taxCodeCNOptions
  );
}


export function setDefZeroVal(val:number) {
  return (isNullOrEmpty(val) ? 0 : val);
}

// Begin,Saber,20261007,INC-1030470
// Credit-card import lines (EECJP2609195F86F and the same batch) already store taxcode/taxamount
// but have no category. Selecting the category binds the rate into state asynchronously, so
// checkAndAutoCalTax still sees an empty ddlTaxCode and leaves the amount at 0.
// Restore the imported amount when the bound code matches; otherwise calculate from the rate
// that was just resolved, not from the stale inputValues snapshot.
function applyBoundTaxAmount(
  id: number,
  taxColNum: number,
  rate: any,
  taxCode: any,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  number_of_decimal: number
) {
  if (inputValues[`hideTaxChk${taxColNum}_${id}`] == 1) {
    return;
  }

  const objAttachment = getObjectAttachment();
  const savedCode = objAttachment?.[`taxcode${taxColNum}`];
  const savedAmount = parseFloat(objAttachment?.[`taxamount${taxColNum}`] ?? 0);
  const codeMatches =
    !isNullOrEmpty(savedCode) &&
    !isNullOrEmpty(taxCode) &&
    savedCode.toString() === taxCode.toString();

  if (codeMatches && !isNaN(savedAmount) && savedAmount !== 0) {
    const decimals = checkInputDecimal(id, inputValues);
    // JPY (and other zero-decimal currencies) floor the imported amount, matching calTaxAmount.
    const displayAmount = decimals === 0 ? Math.floor(savedAmount) : savedAmount;
    handleInputChange(`txtcoderate${taxColNum}_${id}`, displayAmount.toFixed(decimals));
    return;
  }

  calTaxAmount(
    `ddlTaxCode${taxColNum}_${id}`,
    { ...inputValues, [`ddlTaxCode${taxColNum}_${id}`]: rate },
    handleInputChange,
    `txtcoderate${taxColNum}_${id}`,
    number_of_decimal
  );
}
// End,Saber,20261007,INC-1030470


export function checkAndLoadTax(
  cat_id_n: number,
  inputValues: { [key: string]: any | undefined },
  handleInputChange: (id: string, value?: any) => Promise<void>,
  objRequestor: any,
  objAttachment: any,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
) {
  
  const location = getGlobalLocation();
  let transport_detail: string | undefined = objAttachment.transport_type;
  let phone_detail: string | undefined = objAttachment.phone_type_id;

  // Get the values from the DOM elements
  const dateInput = inputValues[`isDateRange`] == "1" ?  inputValues[`txtStartDate${cat_id_n}`] : inputValues[`txtDate${cat_id_n}`];
//   const checkdate = dateInput ? dateInput[0] : "";

  console.log("The checkDate ===>" + dateInput);

  const claimAmountInput = inputValues[`txtClaimAmount${cat_id_n}`] 
  const currencyInput = inputValues[`ddlCurrency${cat_id_n}`] 
  const transportTypeInput = inputValues[`ddlTransportType${cat_id_n}`]
  const phoneTypeInput = inputValues[`ddlPhoneType${cat_id_n}`] 

  // Get tax code attributes for tax columns
  const taxCode1 = inputValues[`ddlTaxCode1_${cat_id_n}_codevalue`];
  const taxCode2 = inputValues[`ddlTaxCode2_${cat_id_n}_codevalue`];
  const taxCode3 = inputValues[`ddlTaxCode3_${cat_id_n}_codevalue`];
  const taxCode4 = inputValues[`ddlTaxCode4_${cat_id_n}_codevalue`];

  let isValid = false;

  // Check each tax amount condition
  if (
    objAttachment.amount_foreign_currency !== claimAmountInput ||
    objAttachment.taxcode1 !== taxCode1 ||
    objAttachment.foreign_currency !== currencyInput ||
    objAttachment.receiptstartdate !== dateInput ||
    transport_detail !== transportTypeInput ||
    phone_detail !== phoneTypeInput
  ) {
    isValid = true;
  }

  if (
    objAttachment.amount_foreign_currency !== claimAmountInput ||
    objAttachment.taxcode2 !== taxCode2 ||
    objAttachment.foreign_currency !== currencyInput ||
    objAttachment.receiptstartdate !== dateInput ||
    transport_detail !== transportTypeInput ||
    phone_detail !== phoneTypeInput
  ) {
    isValid = true;
  }

  if (
    objAttachment.amount_foreign_currency !== claimAmountInput ||
    objAttachment.taxcode3 !== taxCode3 ||
    objAttachment.foreign_currency !== currencyInput ||
    objAttachment.receiptstartdate !== dateInput ||
    transport_detail !== transportTypeInput ||
    phone_detail !== phoneTypeInput
  ) {
    isValid = true;
  }

  if (
    objAttachment.amount_foreign_currency !== claimAmountInput ||
    objAttachment.taxcode4 !== taxCode4 ||
    objAttachment.foreign_currency !== currencyInput ||
    objAttachment.receiptstartdate !== dateInput ||
    transport_detail !== transportTypeInput ||
    phone_detail !== phoneTypeInput
  ) {
    isValid = true;
  }

  // If any of the checks are valid, load the tax column
  if (isValid) {
    loadTaxCol(cat_id_n, inputValues, handleInputChange, location, objAttachment, objRequestor, dateInput || "", handleBindDDL, bindDDL);
  } 
}

export function checkAndBind(
  cat_id_n: number,
  inputValues: { [key: string]: any | undefined }, 
  handleInputChange: (id: string, value?: any) => Promise<void>,
  objRequestor:any,
  objAttachment: any,
  form_mode: string,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
) {
  
  if (objRequestor.country_code == 'CA') {
    for (let iCounter = 1; iCounter < 5; iCounter++) {

        if ((isNullOrEmpty(objAttachment[`taxamount${iCounter}`]) || objAttachment[`taxamount${iCounter}`] == 0) && isElementVisible(`#hideTaxChk${iCounter}_${cat_id_n}`) && inputValues[`hideTaxChk${iCounter}_${cat_id_n}`] !== 1) {
            handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 1);
            subCatInputOnChange({
              ...inputValues, [`hideTaxChk${iCounter}_${cat_id_n}`]: 1}, cat_id_n, `hideTaxChk${cat_id_n}`, handleInputChange, 1);
        }
    }
  }

  const number_of_decimal = decimalRemove();
  if (form_mode == 'edit' || form_mode == 'view') {
    // Check if any taxcode is defined, non-empty, and not null
    const checkctl1 = !isNullOrEmpty(objAttachment.taxcode1);
    const checkctl2 = !isNullOrEmpty(objAttachment.taxcode2);
    const checkctl3 = !isNullOrEmpty(objAttachment.taxcode3);
    const checkctl4 = !isNullOrEmpty(objAttachment.taxcode4);

    // If any of the checks are true, bind the tax column
    if (checkctl1 || checkctl2 || checkctl3 || checkctl4) {
      bindTaxCol(cat_id_n, inputValues, handleInputChange, objRequestor, objAttachment, number_of_decimal, handleBindDDL, bindDDL);
      // if (objRequestor.country_code == 'CA') {
      //       for (let iCounter = 1; iCounter < 5; iCounter++) {

      //           if (isElementVisible(`#hideTaxChk${iCounter}_${cat_id_n}`) && inputValues[`hideTaxChk${iCounter}_${cat_id_n}`] !== 1) {
      //               handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 1);
      //               subCatInputOnChange({
      //                 ...inputValues, [`hideTaxChk${iCounter}_${cat_id_n}`]: 1}, cat_id_n, `hideTaxChk${cat_id_n}`, handleInputChange, 1);
      //           }
      //           else{
      //             if(checkctl1){handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 0);}
      //             if(checkctl2){handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 0);}
      //             if(checkctl3){handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 0);}
      //             if(checkctl4){handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 0);}
      //           }
      //       }
      //   }
    }
  }
}


export function changePerDiemTax(cat_id_n: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>,objRequestor: any) {
  const categoryValue = inputValues[`ddlCategory${cat_id_n}`];
  const countryValue = inputValues[`ddlCountry${cat_id_n}`];

  // MM Country code will have tax on local and abroad country
  if (objRequestor.country_code !== "MM" && categoryValue == "16") {
    for (let iCounter = 1; iCounter < 5; iCounter++) {
      const checkboxElement = document.getElementById(`hideTaxChk${iCounter}_${cat_id_n}`) as HTMLInputElement | null;
      // Must check real rendered visibility (ancestor `#hidetax{n}_{id}` container can be
      // display:none/d-none while this checkbox input itself never carries that class),
      // matching legacy's `$("#hidechk"+n+"_"+id).is(":visible")` ancestor-aware check.
      if (checkboxElement && isElementVisible(`#hideTaxChk${iCounter}_${cat_id_n}`)) {
        // INC-1015869 Per Diem Taxable issue: a real tax code (e.g. JP domestic VX 10%) may exist
        // for this range in TBL_TAX_CHECKING_RATE even when country matches the requestor's home
        // country. bindDDLTaxRate shows #taxcodechecking{n} synchronously via direct DOM manipulation
        // when it resolves a non-zero tax code - inputValues can be stale here (still batching from
        // the same call chain), so check the DOM directly instead of guessing by country.
        if (isElementVisible(`#taxcodechecking${iCounter}_${cat_id_n}`)) {
          continue;
        }

        disableInput(`#hideTaxChk${iCounter}_${cat_id_n}`, false, "text");

        if (objRequestor.country_code !== countryValue) {
          handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 0);
        } else {
          handleInputChange(`hideTaxChk${iCounter}_${cat_id_n}`, 1);
        }

        checkboxElement.click();
        // Simulating the 'click' event programmatically
        checkboxElement.dispatchEvent(new Event("click"));

        if (objRequestor.country_code !== countryValue) {
          disableInput(`#hideTaxChk${iCounter}_${cat_id_n}`, true, "text");
        }
      }
    }
  }
}


export function checkAndAutoCalTax(cat_id_n: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, objRequestor:any, objAttachment: any) {
  // auto calculate value
  // If more than one tax rate is present, this won't automatically till user choose one
  if (objRequestor.country_code == "TW") {
    return;
  }
  const number_of_decimal = decimalRemove();
  let transport_detail = objAttachment.transport_type ?? undefined;
  let phone_detail = objAttachment.phone_type_id ?? undefined;
  const checkdate = inputValues[`isDateRange`] == 1 ? inputValues[`txtStartDate${cat_id_n}`] : inputValues[`txtDate${cat_id_n}`];
  // const checkdate = dateval[0];

  // Set control where one tax column will only trigger autocalculation
  const taxCode2Value = (document.getElementById(`ddlTaxCode2_${cat_id_n}`) as HTMLSelectElement)?.value;
  let onetaxcal = !taxCode2Value;

  const autocal_checking = localStorage.getItem("AutoCalTax");

  // Helper function to calculate tax
  const calculateTax = (taxCodeId: string, rateId: string, index: number) => {
    if (!(inputValues[`hideTaxChk${index}_${cat_id_n}`] == 1)) {
      if (
        objAttachment.amount_foreign_currency !== inputValues[`txtClaimAmount${cat_id_n}`]  ||
        objAttachment[`taxcode${index}`] !== inputValues[`${taxCodeId}_codevalue`]  ||
        objAttachment.foreign_currency !== inputValues[`ddlCurrency${cat_id_n}`] ||
        objAttachment.receiptstartdate !== checkdate ||
        transport_detail !== inputValues[`ddlTransportType${cat_id_n}`]  ||
        phone_detail !== inputValues[`ddlPhoneType${cat_id_n}`]  ||
        // Begin,Saber,20260909,SR-1032825 - taxamount is numeric but inputValues[rateId] is
        // always a string (toFixed()'d); strict !== was always true, forcing a recalculation
        // that discarded the just-restored saved/edited tax amount on every load.
        parseFloat(objAttachment[`taxamount${index}`] ?? 0) !== parseFloat(inputValues[rateId] ?? 0)
        // End,Saber,20260909,SR-1032825
      ) {
        calTaxAmount(taxCodeId, inputValues, handleInputChange, rateId, number_of_decimal);
        localStorage.setItem("AutoCalTax", "Yes");
      } else if (autocal_checking == "Yes") {
        calTaxAmount(taxCodeId, inputValues, handleInputChange, rateId, number_of_decimal);
      }
    } else {
      // (document.getElementById(rateId) as HTMLInputElement).value = "0.00";
      if (objRequestor.country_code == "CN") {
        calTaxAmount(taxCodeId, inputValues, handleInputChange, rateId, number_of_decimal);
      }
      
    }
  };

  // Calculate tax amounts for tax codes 1-4
  calculateTax(`ddlTaxCode1_${cat_id_n}`, `txtcoderate1_${cat_id_n}`, 1);
  calculateTax(`ddlTaxCode2_${cat_id_n}`, `txtcoderate2_${cat_id_n}`, 2);
  calculateTax(`ddlTaxCode3_${cat_id_n}`, `txtcoderate3_${cat_id_n}`, 3);
  calculateTax(`ddlTaxCode4_${cat_id_n}`, `txtcoderate4_${cat_id_n}`, 4);


  if (objRequestor.country_code == "CN") {
    (document.querySelector('select[name=TaxCodeCN]') as HTMLSelectElement)?.dispatchEvent(new Event('change'));
  }
}


export function bindTaxCol
  (idNum: number, 
  inputValues: { [key: string]: any | undefined }, 
  handleInputChange: (id: string, value?: any) => Promise<void>, 
  objRequestor:any, 
  objAttachment:any, 
  number_of_decimal:number,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
){
    let category = objAttachment.subcategory_id;
    let phoneDetail = objAttachment.phone_type_id;
    let transportDetail = objAttachment.transport_type;
    const currency = objAttachment.foreign_currency;
    const tempDate = new Date(objAttachment.receipt_start_date);
    let range: string;
    const taxOptions: string[] = [];
    let count = 0;
    let isValid = true;

    const currentUserInfo: any = JSON.parse(localStorage.getItem("objRequestor") || '[]');
    if (currentUserInfo.country_code == 'TH') {
        isValid = false;
    }

    if (isValid) {
        if (category) {
            // Corporate Credit when user change or edit
            if (objAttachment.iS_CC == "1") {
                // Begin,Saber,20260909,SR-1032825 - inputValues[ddlCategory] can still be
                // empty/stale on initial load (not yet committed to this render's closure);
                // falling back to it unconditionally cleared `category`, skipping the whole
                // saved-tax restore below and leaving the amount at whatever setDefaultTax
                // last reset it to. Only trust the live dropdown value once populated.
                if (!isNullOrEmpty(inputValues[`ddlCategory${idNum}`])) {
                    category = inputValues[`ddlCategory${idNum}`];
                }
                // End,Saber,20260909,SR-1032825

                // Update transport detail
                if (inputValues[`ddlTransportType${idNum}`]!= transportDetail) {
                    transportDetail = inputValues[`ddlTransportType${idNum}`];
                }

                // Update Phone detail
                if (inputValues[`ddlPhoneType${idNum}`] != phoneDetail) {
                    phoneDetail = inputValues[`ddlPhoneType${idNum}`] ;
                }

                if ((transportDetail == "" || transportDetail == null) && category == '4') {
                    category = '';
                }
                if ((phoneDetail == "" || phoneDetail == null) && category == '26') {
                    category = '';
                }
            }
        } else if (!isNullOrEmpty(inputValues[`ddlCategory${idNum}`])) {
            category = inputValues[`ddlCategory${idNum}`];

            if (objAttachment.iS_CC == "1") {
                if (inputValues[`ddlTransportType${idNum}`]!= transportDetail) {
                    transportDetail = inputValues[`ddlTransportType${idNum}`];
                }

                if (inputValues[`ddlPhoneType${idNum}`] != phoneDetail) {
                    phoneDetail = inputValues[`ddlPhoneType${idNum}`] ;
                }
                if ((isNullOrEmpty(transportDetail)) && category == '4') {
                    category = '';
                }
                if ((isNullOrEmpty(phoneDetail)) && category == '26') {
                    category = '';
                }
            }
        }

        if (!isNullOrEmpty(category)) {
            localStorage.setItem('TaxCompulsory', 'Yes');
            const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;

            range = (currency == objRequestor.currency_code) ? 'Local' : 'Abroad';

            if ((transportDetail == null || transportDetail == '') && (phoneDetail == null || phoneDetail == '')) {
                if (objtaxratechk) {
                    for (const taxRate of objtaxratechk) {
                        if (taxRate.subcategory_id == category) {
                            const checkDate = new Date(taxRate.effectiveDate);
                            if (tempDate >= checkDate && taxRate.range == range) {
                                if (taxRate.detail_id == null && taxRate.rate == 0) {
                                    localStorage.setItem('TaxCompulsory', 'No');
                                }
                            }
                        }
                    }
                }

                // Collect tax codes
                for (let i = 1; i <= 4; i++) {
                    const taxCode = objAttachment[`taxcode${i}`];
                    if (taxCode) {
                        count++;
                        taxOptions.push(taxCode);
                    }
                }

                bindDDLTaxRate(count, objtaxratechk, category, tempDate, range, taxOptions, idNum, inputValues, handleInputChange, true, number_of_decimal, handleBindDDL, bindDDL);
                console.log(objAttachment.taxamount2);
                handleInputChange(`txtcoderate${1}_${idNum}`, (objAttachment.taxamount1 || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${2}_${idNum}`, (objAttachment.taxamount2 || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${3}_${idNum}`, (objAttachment.taxamount3 || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${4}_${idNum}`, (objAttachment.taxamount4 || 0 as number).toFixed(number_of_decimal));

                for (let i = 1; i <= 4; i++) {
                    const txtCodeRate = objAttachment[`taxamount${i}`];
                    if (txtCodeRate == '0' && objAttachment[`taxcode${i}`] !== null) {
                        if (objAttachment[`taxamount${i}`] !== null) {
                            // (document.getElementById(`hideTaxChk${i}_${idNum}`) as HTMLInputElement).click();
                            handleInputChange(`hideTaxChk${i}_${idNum}`, 1);
                        }
                        if (txtCodeRate == '0' && inputValues[`hideTaxChk${i}_${idNum}`] != 1) {
                            calTaxAmount(`ddlTaxCode${i}_${idNum}`, inputValues, handleInputChange, `txtcoderate${i}_${idNum}`, number_of_decimal);
                        }
                    }
                }

                if (currentUserInfo.country_code == 'CN') {
                    // Determine the active CN tax code from objAttachment (not stale inputValues)
                    // First pass: find which taxcode has a non-zero amount (the selected one)
                    let resolvedTaxCodeCN: string | null = null;
                    for (let k = 1; k <= 4; k++) {
                        const taxAmtK = objAttachment[`taxamount${k}`];
                        const taxCodeK = objAttachment[`taxcode${k}`];
                        if (!isNullOrEmpty(taxCodeK) && taxAmtK != '0' && taxAmtK != 0) {
                             resolvedTaxCodeCN = taxCodeK;
                        }
                    }

                    // Single loop: set CN dropdown + mark matching/non-matching tax columns
                    for (let k = 1; k <= 4; k++) {
                        const codeValue = objAttachment[`taxcode${k}`];
                        if (!isNullOrEmpty(codeValue) && codeValue === resolvedTaxCodeCN) {
                            handleInputChange(`hideTaxChk${k}_${idNum}`, 0);
                            handleInputChange(`ddlTaxCodeCN_${idNum}`, codeValue);
                            handleInputChange(`txtcoderateCN_${idNum}`, parseFloat(objAttachment[`taxamount${k}`] || 0).toFixed(number_of_decimal));
                        } else if (!isNullOrEmpty(codeValue)) {
                            handleInputChange(`hideTaxChk${k}_${idNum}`, 1);
                            handleInputChange(`txtcoderate${k}_${idNum}`, "0");
                        }
                    }

                    if (isNullOrEmpty(resolvedTaxCodeCN)) {
                        handleInputChange(`ddlTaxCodeCN_${idNum}`, "0");
                        (document.querySelector('select[name=TaxCodeCN]') as HTMLSelectElement)?.dispatchEvent(new Event('change'));
                    }
                }
            }

            // Transport Detail Type
            if (transportDetail) {
                if (objtaxratechk) {
                    for (const taxRate of objtaxratechk) {
                        if (taxRate.subcategory_id == category && taxRate.detail_id == transportDetail) {
                            const checkDate = new Date(taxRate.effectiveDate);
                            if (tempDate >= checkDate && taxRate.range == range) {
                                if (taxRate.rate == 0) {
                                    localStorage.setItem('TaxCompulsory', 'No');
                                }
                            }
                        }
                    }
                }

                // Collect tax codes for transport
                for (let i = 1; i <= 4; i++) {
                    const taxCode = objAttachment[`taxcode${i}`];
                    if (taxCode) {
                        count++;
                        taxOptions.push(taxCode);
                    }
                }
                
                bindDDLTaxRateDtl(count, objtaxratechk, category, transportDetail, tempDate, range, taxOptions, idNum, inputValues, handleInputChange, number_of_decimal, handleBindDDL, bindDDL);
                
                handleInputChange(`txtcoderate${1}_${idNum}`, (objAttachment.taxamount1  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${2}_${idNum}`, (objAttachment.taxamount2  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${3}_${idNum}`, (objAttachment.taxamount3  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${4}_${idNum}`, (objAttachment.taxamount4  || 0 as number).toFixed(number_of_decimal));

                for (let i = 1; i <= 4; i++) {
                    const txtCodeRate = objAttachment[`taxamount${i}`];
                    if (txtCodeRate == '0' && objAttachment[`taxcode${i}`] !== null) {
                        if (objAttachment[`taxamount${i}`] !== null) {
                            (document.getElementById(`hideTaxChk${i}_${idNum}`) as HTMLInputElement).click();
                        }
                        if (txtCodeRate == '0' && inputValues[`hideTaxChk${i}_${idNum}`] != "1") {
                            calTaxAmount(`ddlTaxCode${i}_${idNum}`, inputValues, handleInputChange, `txtcoderate${i}_${idNum}`, number_of_decimal);
                        }
                    }
                }
            }

            // Phone Detail Type
            if (phoneDetail) {
                if (objtaxratechk) {
                    for (const taxRate of objtaxratechk) {
                        if (taxRate.subcategory_id == category && taxRate.detail_id == phoneDetail) {
                            const checkDate = new Date(taxRate.effectiveDate);
                            if (tempDate >= checkDate && taxRate.range == range) {
                                if (taxRate.rate == 0) {
                                    localStorage.setItem('TaxCompulsory', 'No');
                                }
                            }
                        }
                    }
                }

                // Collect tax codes for phone
                for (let i = 1; i <= 4; i++) {
                    const taxCode = objAttachment[`taxcode${i}`];
                    if (taxCode) {
                        count++;
                        taxOptions.push(taxCode);
                    }
                }

                bindDDLTaxRateDtl(count, objtaxratechk, category, phoneDetail, tempDate, range, taxOptions, idNum, inputValues, handleInputChange, number_of_decimal, handleBindDDL, bindDDL);
                
                handleInputChange(`txtcoderate${1}_${idNum}`, (objAttachment.taxamount1  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${2}_${idNum}`, (objAttachment.taxamount2  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${3}_${idNum}`, (objAttachment.taxamount3  || 0 as number).toFixed(number_of_decimal));
                handleInputChange(`txtcoderate${4}_${idNum}`, (objAttachment.taxamount4  || 0 as number).toFixed(number_of_decimal));

                for (let i = 1; i <= 4; i++) {
                    const txtCodeRate = objAttachment[`taxamount${i}`];
                    if (txtCodeRate == '0' && objAttachment[`taxcode${i}`] !== null) {
                        if (objAttachment[`taxamount${i}`] !== null) {
                            (document.getElementById(`hideTaxChk${i}_${idNum}`) as HTMLInputElement).click();
                        }
                        if (txtCodeRate == '0' && inputValues[`hideTaxChk${i}_${idNum}`] != "1") {
                            calTaxAmount(`ddlTaxCode${i}_${idNum}`, inputValues, handleInputChange, `txtcoderate${i}_${idNum}`, number_of_decimal);
                        }
                    }
                }
            }
        }
    }
}


export function cN_Tax_WorkAround(id_num: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>){
    let taxCodeCN = inputValues[`ddlTaxCodeCN_${id_num}`];
    
    for (let k = 1; k <= 4; k++) {
        let hideCheckBox = inputValues[`hideTaxChk${k}_${id_num}`];
        let taxCodeDropdown = inputValues[`ddlTaxCode${k}_${id_num}`];
        
        let codeValue = inputValues[`ddlTaxCode${k}_${id_num}_codevalue`]

        if (hideCheckBox != 1 && codeValue !== taxCodeCN) {
            handleInputChange(`hideTaxChk${k}_${id_num}`, 1);
            handleInputChange(`txtcoderate${k}_${id_num}`, "0");
        }

        if (hideCheckBox == 1 && codeValue == taxCodeCN) {
            handleInputChange(`hideTaxChk${k}_${id_num}`, 0);
        }

        if (hideCheckBox == 1) {
           handleInputChange(`txtcoderate${k}_${id_num}`, "0");
        }
    }

    if (isNullOrEmpty(taxCodeCN)) {
        handleInputChange(`ddlTaxCodeCN_${id_num}`, "0");
    }
}


export function setDefaultTax(id_num: number, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, location:any, objAttachment: any, objRequestor: any, input_decimal: number = 0){
    // Tax compulsory message
    
    location = getGlobalLocation();
    elementDisplay(`#taxcompulsorymsg_${id_num}`, false, "div");

    //tax column CN
    elementDisplay(`#taxcodecheckingCN_${id_num}`, false, "div");
    document.querySelector<HTMLInputElement>(`#taxcodecheckingCN_${id_num} option`)?.remove();
    mandatoryInput(`#ddlTaxCodeCN_${id_num}`, false, "select");
    mandatoryInput(`#txtcoderateCN_${id_num}`, false, "select");
    handleInputChange(`ddlTaxCodeCN_${id_num}`, 0);

    //tax column A
    elementDisplay(`#taxcodechecking1_${id_num}`, false, "div");
    document.querySelector<HTMLInputElement>(`#taxcodechecking1_${id_num} option`)?.remove();
    mandatoryInput(`#ddlTaxCode1_${id_num}`, false, "select");
    mandatoryInput(`#txtcoderate1_${id_num}`, false, "select");
    handleInputChange(`ddlTaxCode1_${id_num}`, null);
    handleInputChange(`ddlTaxCode1_${id_num}_codevalue`, null);
    handleInputChange(`txtcoderate1_${id_num}`, 0);
    elementDisplay(`#hidetax1_${id_num}`, false, "div");
    handleInputChange(`hideTaxChk1_${id_num}`, 0);

    //tax column B
    elementDisplay(`#taxcodechecking2_${id_num}`, false, "div");
    document.querySelector<HTMLInputElement>(`#taxcodechecking2_${id_num} option`)?.remove();
    mandatoryInput(`#ddlTaxCode2_${id_num}`, false, "select");
    mandatoryInput(`#txtcoderate2_${id_num}`, false, "select");
    handleInputChange(`ddlTaxCode2_${id_num}`, null);
    handleInputChange(`ddlTaxCode2_${id_num}_codevalue`, null);
    handleInputChange(`txtcoderate2_${id_num}`, 0);
    elementDisplay(`#hidetax2_${id_num}`, false, "div");
    handleInputChange(`hideTaxChk2_${id_num}`, 0);

    //tax column C
    elementDisplay(`#taxcodechecking3_${id_num}`, false, "div");
    document.querySelector<HTMLInputElement>(`#taxcodechecking3_${id_num} option`)?.remove();
    mandatoryInput(`#ddlTaxCode3_${id_num}`, false, "select");
    mandatoryInput(`#txtcoderate3_${id_num}`, false, "select");
    handleInputChange(`ddlTaxCode3_${id_num}`, null);
    handleInputChange(`ddlTaxCode3_${id_num}_codevalue`, null);
    handleInputChange(`txtcoderate3_${id_num}`, 0);
    elementDisplay(`#hidetax3_${id_num}`, false, "div");
    handleInputChange(`hideTaxChk3_${id_num}`, 0);

    //tax column D
    elementDisplay(`#taxcodechecking4_${id_num}`, false, "div");
    document.querySelector<HTMLInputElement>(`#taxcodechecking4_${id_num} option`)?.remove();
    mandatoryInput(`#ddlTaxCode4_${id_num}`, false, "select");
    mandatoryInput(`#txtcoderate4_${id_num}`, false, "select");
    handleInputChange(`ddlTaxCode4_${id_num}`, null);
    handleInputChange(`ddlTaxCode4_${id_num}_codevalue`, null);
    handleInputChange(`txtcoderate4_${id_num}`, 0);
    elementDisplay(`#hidetax4_${id_num}`, false, "div");
    handleInputChange(`hideTaxChk4_${id_num}`, 0);

    if(!isNullOrEmpty(location)){
      if (!isNullOrEmpty(location.state?.pageMode) && location.state?.pageMode == 'finance') {
        if (objAttachment?.company_code !== undefined) {
            const claimAmount = parseFloat(objAttachment.amount_foreign_currency);
            if (objAttachment.company_code.includes("JP")) {
                handleInputChange(`txtClaimAmount${id_num}`, claimAmount.toFixed(2));
            } else {
                handleInputChange(`txtClaimAmount${id_num}`, claimAmount.toFixed(input_decimal));
            }
        } else if (objAttachment.subcategory_id == 46 || objAttachment.subcategory_id == 47) {
            handleInputChange(`txtClaimAmount${id_num}`, parseFloat(objAttachment.amount_foreign_currency).toFixed(input_decimal));
        } else if (objAttachment.subcategory_id == 48) {
            handleInputChange(`txtClaimAmount${id_num}`, parseFloat(objAttachment.total_amount).toFixed(input_decimal));
        }

        handleInputChange(`txtClaimAmount${id_num}`, parseFloat(objAttachment.total_amount).toFixed(input_decimal));

        handleInputChange(`ddlCurrency${id_num}`, objRequestor.currency_code);
        disableInput(`#ddlCurrency${id_num}`, true, "select");
        disableInput(`#txtClaimAmount${id_num}`, true, "text");
      }

    }

}


export function calTaxAmount(idName: string, inputValues: { [key: string]: any | undefined }, handleInputChange: (id: string, value?: any) => Promise<void>, txtId: string,  numberOfDecimal: number): void {
    let taxAmount = 0;

    const numberOfPage = idName.slice(-1) == '0' ? 10 : Number(idName.slice(-1));
  const currencyInputDecimal = checkInputDecimal(numberOfPage, inputValues);
    console.log("idName :" + idName + " : " +inputValues[idName] );
    if(!isNullOrEmpty(inputValues[idName])){
       const taxRateVal = (Number(inputValues[idName]) / 100) + 1;

        taxAmount = Number(inputValues[`txtClaimAmount${numberOfPage}`]) - 
                    (Number(inputValues[`txtClaimAmount${numberOfPage}`]) / taxRateVal);

        const decimalRounding45Rule = is45RoundingApplies(appConfig.DecimalRounding45Rule);

        if (decimalRounding45Rule) {
            taxAmount = Math.round(taxAmount);
        }

        if (currencyInputDecimal == 0) {
            taxAmount = Math.floor(taxAmount);
        }

        console.log("the claim amount :" + inputValues[`txtClaimAmount${numberOfPage}`]);
        console.log("the tax amount :" + taxAmount);
        console.log("the txtId :" + txtId);
        console.log(`the inputValues[${idName}] :` + inputValues[idName]);
        console.log(`the taxRateVal :` + taxRateVal);

        handleInputChange(`${txtId}`, taxAmount.toFixed(currencyInputDecimal));

        const currentUserInformation = JSON.parse(localStorage.getItem("objRequestor") || '[]');

        // Bind the calculated amount to CN dropdown
        if (currentUserInformation?.country_code == 'CN') {
            const index = txtId.slice(-1) == '0' ? 10 : Number(txtId.slice(-1));
            console.log("idName : " + idName);
            if (inputValues[idName] == inputValues[`ddlTaxCodeCN_${index}_text`]) {
              handleInputChange(`txtcoderateCN_${index}`, taxAmount.toFixed(currencyInputDecimal));
            }
            else{
              handleInputChange(`${txtId}`, 0);
            }

            if(inputValues[`ddlTaxCodeCN_${index}_text`] == 0){
              handleInputChange(`txtcoderateCN_${index}`, "0");
            }
        }

    }

    if(idName == txtId){
      const objAttachment = getObjectAttachment();
      if(!isNullOrEmpty(objAttachment) && !isNullOrEmpty(objAttachment[`taxamount${numberOfPage}`])){
        // handleInputChange(`${txtId}`, objAttachment[`taxamount${numberOfPage}`].toFixed(numberOfDecimal));
      }
    }
   
}

export function loadTaxCol
( i: number, 
  inputValues: { [key: string]: any | undefined }, 
  handleInputChange: (id: string, value?: any) => Promise<void>, 
  location:any, 
  objAttachment: any, 
  objRequestor:any,  
  val: string | null,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
){
    const number_of_decimal = decimalRemove();
    
    // Default running
    let isValid = true;

    setDefaultTax(i, inputValues, handleInputChange, location, objAttachment, objRequestor, number_of_decimal);

    // Tax function will only apply to all other countries except Thailand
    const currentUserInformation = JSON.parse(localStorage.getItem("objRequestor") || '[]');
    if (currentUserInformation?.country_code == 'TH') {
        isValid = false;
    }

    if (isValid) {
        // Trigger Check Tax Columns
      if(!isNullOrEmpty(val)){
          const tempCatVal = inputValues[`ddlCategory${i}`];
          const transportDetailExists = inputValues[`ddlTransportType${i}`];
          const phoneDetailExists = inputValues[`ddlPhoneType${i}`];
          // const checkingDate = val!.split(" - ");
          const tempDate = format(val!, "MM/dd/yyyy"); 

          const cur = (!isNullOrEmpty(objAttachment) && objAttachment.iS_CC == 1) ? objAttachment.foreign_currency : inputValues[`ddlCurrency${i}`];
          const range = cur == objRequestor.currency_code ? 'Local' : 'Abroad';

          if (transportDetailExists != null) {
              // Detail Column exists
              // Cater for tax where it has subcategory id together with transport detail ID
              if (tempCatVal != null) {
                  // Function CheckTaxDetail
                  checkTaxDetail(inputValues[`ddlTransportType${i}`], i, inputValues, handleInputChange, tempDate, range, number_of_decimal, handleBindDDL, bindDDL);
              }
          } else if (phoneDetailExists != null) {
              // Detail Column exists
              // Cater for tax where it has subcategory id together with phone detail ID
              if (tempCatVal != null) {
                  // Function CheckTaxDetail
                  checkTaxDetail(inputValues[`ddlPhoneType${i}`], i, inputValues, handleInputChange, tempDate, range, number_of_decimal, handleBindDDL, bindDDL);
              }
          } else {
              // Detail Column does not exist
              // Cater for tax where it only has subcategory id
              if (tempCatVal != null) {
                  // Function CheckCategoryItem for Tax percentage
                  checkTaxCategory(inputValues[`ddlCategory${i}`], i, inputValues, handleInputChange, tempDate, range, number_of_decimal, handleBindDDL, bindDDL);
              }
          }

          if (objRequestor.country_code == 'CA') {
            let objAttachment = getObjectAttachment();
            for (let iCounter = 1; iCounter < 5; iCounter++) {

                if ((isNullOrEmpty(objAttachment[`taxamount${iCounter}`]) || objAttachment[`taxamount${iCounter}`] == 0 ) && isElementVisible(`#hideTaxChk${iCounter}_${i}`) && inputValues[`hideTaxChk${iCounter}_${i}`] !== 1) {
                    handleInputChange(`hideTaxChk${iCounter}_${i}`, 1);
                    subCatInputOnChange({
                      ...inputValues, [`hideTaxChk${iCounter}_${i}`]: 1}, i, `hideTaxChk${i}`, handleInputChange, 1);
                }
            }
          }
      }

        
    }
}


export function checkTaxDetail
(
  obj: string, 
  id: number, 
  inputValues: { [key: string]: any | undefined }, 
  handleInputChange: (id: string, value?: any) => Promise<void>, 
  date: string, 
  range: string, 
  number_of_decimal:number,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
){
    
  let count = 0;
    const taxrateoption: string[] = [];
    const subcategoryId = inputValues[`ddlCategory${id}`];
    const dateParts = date.split('/');
    const tempDate = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
    const currentUserInformation = JSON.parse(localStorage.getItem("objRequestor") || '[]');
    const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;

    localStorage.setItem('TaxCompulsory', 'Yes');

    if(!isNullOrEmpty(objtaxratechk)){
      for (let i = 0; i < objtaxratechk.length; i++) {
        if (objtaxratechk[i].subcategory_id == subcategoryId) {
            if (objtaxratechk[i].detail_id == obj) {
                const checkDate = new Date(objtaxratechk[i].effectiveDate);
                const expiryDate = new Date(objtaxratechk[i].expiryDate);

                // Match Effective Date and match currency range (local or abroad)
                if (
                    tempDate >= checkDate &&
                    objtaxratechk[i].range == range &&
                    (tempDate <= expiryDate || objtaxratechk[i].expiryDate == null)
                ) {
                    if (currentUserInformation?.country_code == 'CN') {
                        count += 1;
                        taxrateoption.push(objtaxratechk[i].taxCode);
                    } else {
                        if (objtaxratechk[i].rate !== 0 || currentUserInformation?.country_code == 'CA') {
                            count += 1;
                            taxrateoption.push(objtaxratechk[i].taxCode);
                        }
                    }

                    // Tax amount mandatory control
                    if (objtaxratechk[i].rate == 0) {
                        localStorage.setItem('TaxCompulsory', 'No');
                    }
                }
            }
        }
    }

    }
 

    if (count > 0) {
        bindDDLTaxRateDtl(count, objtaxratechk, subcategoryId, parseInt(obj), tempDate, range, taxrateoption, id, inputValues, handleInputChange, number_of_decimal, handleBindDDL, bindDDL);
    }
}


export function checkTaxCategory
(
  obj: string, 
  id: number, 
  inputValues: { [key: string]: any | undefined }, 
  handleInputChange: (id: string, value?: any) => Promise<void> ,
  date: string, 
  range: string, 
  number_of_decimal:number,
  handleBindDDL?: (id: string, value?: any) => void,
  bindDDL?: { [key: string]: any | undefined }
) {
    
  let count = 0;
    const taxrateoption: string[] = [];
    const dateParts = date.split('/');
    const tempDate = new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
    const currentUserInformation = JSON.parse(localStorage.getItem("objRequestor") || '[]');
    const objtaxratechk = !isNullOrEmpty(localStorage.getItem("tax_rate_checking")) ? JSON.parse(localStorage.getItem("tax_rate_checking")!) : null;


    localStorage.setItem('TaxCompulsory', 'Yes');

    if(!isNullOrEmpty(objtaxratechk)){
      if (objtaxratechk && objtaxratechk.length) {
        for (let i = 0; i < objtaxratechk.length; i++) {
            // Match SubCategory
            if (objtaxratechk[i].subcategory_id == obj) {
                const checkDate = new Date(objtaxratechk[i].effectiveDate);
                const expiryDate = new Date(objtaxratechk[i].expiryDate);

                // Match Effective Date and match currency range (local or abroad)
                if (
                    tempDate >= checkDate &&
                    objtaxratechk[i].range == range &&
                    (tempDate <= expiryDate || objtaxratechk[i].expiryDate == null)
                ) {
                    // Only applicable to category tax without detail id
                    if (objtaxratechk[i].detail_id == null) {
                        if (currentUserInformation?.country_code == 'CN') {
                            count += 1;
                            taxrateoption.push(objtaxratechk[i].taxCode);
                        } else {
                            if (objtaxratechk[i].rate !== 0 || currentUserInformation?.country_code == 'CA') {
                                count += 1;
                                taxrateoption.push(objtaxratechk[i].taxCode);
                            }
                        }

                        // Tax amount mandatory control
                        if (objtaxratechk[i].rate == 0) {
                            localStorage.setItem('TaxCompulsory', 'No');
                        }
                    }
                }
            }
        }
    }

    }


    // Process all tax applicable to this category
    if (count > 0) {
        // Terk Amendment 20240312 [#CHN-9651]
        if (currentUserInformation?.country_code == "PH" && (obj == '28' || obj == '29' || obj == '45')) {
            const val = inputValues[`rdExpenseNature${id}_radio_value`] || '';

            const index = taxrateoption.indexOf(val || '');

            console.log("taxVal : " + val);

            let selectedTaxCode = taxrateoption[index];
            taxrateoption.length = 0; // Clear the array
            if (index > -1) { // Only splice array when item is found
                taxrateoption.push(selectedTaxCode);
            }
        }

        bindDDLTaxRate(count, objtaxratechk, parseInt(obj), tempDate, range, taxrateoption, id, inputValues, handleInputChange, false, number_of_decimal , handleBindDDL, bindDDL);
    }
}